import { Grid, Theme, Typography } from '@material-ui/core';
import { AlternateEmail, MailOutline, PhoneOutlined } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import { Button, Card } from 'bc-front-sagacomponents';
import React, { useEffect } from 'react';
import IllustrationContactSvg from '../../../images/illustration-contact';
import Important from '../../../images/Important';
import { useDemandeRemboursement } from '../selectors';
import styles from '../style';

interface Props {
  classes?: any;
  theme?: Theme;
}

const DemandeRemboursementContent = (props: Props) => {
  const { classes, theme } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { handleClickDocument, fetching } = useDemandeRemboursement();

  return (
    <>
      <div className={classes.title}>
        <Typography variant="h2">
          <strong>Vous avez un sinistre à déclarer</strong>
        </Typography>{' '}
        <Button
          variant="contained"
          color="secondary"
          title="Télécharger la déclaration de sinistre"
          onClick={handleClickDocument}
          fetching={fetching}
        />
      </div>
      <Card className={classes.contentRemboursement}>
        <Grid container alignContent="center" wrap="nowrap">
          <Important width={16} className={classes.iconImportant} />
          <Typography variant="body1">
            A compter de la date du sinistre et dans le délai imposé par les conditions générales de votre contrat.
          </Typography>
        </Grid>
        <br />
        <Typography variant="h4">
          Pour solliciter la prise en charge du remboursement de votre franchise automobile*
        </Typography>
        <Grid container alignContent="center">
          <div className={classes.imgContact}>
            <IllustrationContactSvg
              color1={theme ? theme.palette.secondary.main : ''}
              color2={theme ? theme.palette.secondary.light : ''}
            ></IllustrationContactSvg>
          </div>
          <div className={classes.contactSaga}>
            <p>Vous devez prendre contact avec SAGA Service Plus : </p>
            <p>
              <MailOutline /> Par&nbsp;courrier&nbsp;:
              <strong>46 bis rue des hauts pavés BP 52216 - 44022 NANTES Cedex 01</strong>
            </p>
            <p>
              <PhoneOutlined /> Par téléphone au
              <a href={'tel:0240356334'}>02 40 35 63 34</a>
              <span>(du lundi au vendredi de 10h à 12h30 et de 14h à 17h)</span>
            </p>
            <p>
              <AlternateEmail /> Par email
              <a href="mailto:contact@sagaserviceplus.fr">contact@sagaserviceplus.fr</a>
            </p>
          </div>
        </Grid>
        <p>
          Vous trouverez ci-dessus un modèle de courrier à nous adresser que vous pouvez imprimer auquel nous vous
          remercions de joindre :
        </p>
        <ul className={classes.listSaga}>
          <li>Une déclaration circonstanciée de l'évènement à l'origine de votre sinistre</li>
          <li>
            La copie des conditions particulières de votre contrat d'assurance automobile qui mentionne le montant de la
            franchise à votre charge
          </li>
          <li>La copie de la lettre de prise en charge ou de la lettre de règlement de votre assureur automobile</li>
          <li>La copie du constat amiable d'accident</li>
          <li>La copie du rapport d'expertise</li>
          <li>La copie de la facture de réparations</li>
          <li>La copie de la facture d'achat de votre véhicule (en cas de vol ou de mise en épave)</li>
          <li>La copie du dépôt de plainte (en cas de délit de fuite ou de vol du véhicule)</li>
        </ul>
        <span className={classes.legend}>
          * Selon la formule choisie et dans les termes fixés par les conditions générales de votre contrat
        </span>
      </Card>
    </>
  );
};
export default withStyles(styles)(DemandeRemboursementContent);
